angular.module('bookAndPay').controller('ShowEventsCtrl', ["$scope", "$state", "$window", "DataService", "cart", "events", function($scope, $state, $window, DataService, cart, events) {
  $scope.cart = cart;
  $scope.events = events.plain ? events.plain() : events;
  $scope.currency = DataService.currency;
  $scope.chooseEvent = function(event) {
    $scope.isLoading = true;
    $scope.cart.event_id = event.id;
    return $scope.cart.save().then(function(response) {
      $scope.isLoading = false;
      return $state.go('bookAndPay.editCart', {
        uuid: $scope.cart.cart_uuid
      });
    }, function(response) {
      $scope.errors = response.data.errors;
      $scope.isLoading = false;
      return $window.scrollTo(0, 0);
    });
  };
  $scope.displayTime = function(event) {
    var end, start;
    start = moment(event.start, 'YYYY/MM/DD HH:mm').format('ddd, D MMM [at] h:mm');
    end = moment(event.end, 'YYYY/MM/DD HH:mm').format('h:mma');
    return `${start}-${end}`;
  };
  return $scope.cancelBooking = function() {
    if ($window.confirm("Are you sure you want to cancel your booking?")) {
      return $state.go('bookAndPay.newCart', {
        uuid: cart.membership_plan_uuid
      });
    }
  };
}]);
